export const ENTERPRISE_GPU_DATA = {
  heading: "Enterprise GPU ",
  data: [
    {
      vcpus: 24,
      memory: "92 GB",
      gpu: "1 x L4 24 GB",
      nvme: "400 GB",
      hourlyPrice: 1.25,
    },
    {
      vcpus: 48,
      memory: "192 GB",
      gpu: "2 x L4 24 GB",
      nvme: "800 GB",
      hourlyPrice: 2.5,
    },
    {
      vcpus: 16,
      memory: "48 GB",
      gpu: "1 x T4 16 GB",
      nvme: "400 GB",
      hourlyPrice: 0.35,
    },
    {
      vcpus: 32,
      memory: "96 GB",
      gpu: "2 x T4 16 GB",
      nvme: "640 GB",
      hourlyPrice: 0.6,
    },
    {
      vcpus: 32,
      memory: "192 GB",
      gpu: "1 x L40S 48 GB",
      nvme: "1400 GB",
      hourlyPrice: 1.65,
    },
    {
      vcpus: 48,
      memory: "384 GB",
      gpu: "2 x L40S 48 GB",
      nvme: "2400 GB",
      hourlyPrice: 4.2,
    },
    {
      vcpus: 80,
      memory: "1024 GB",
      gpu: "4 x L40S 48 GB",
      nvme: "4800 GB",
      hourlyPrice: 8.0,
    },
  ],
};
